import dayjs from 'dayjs';

export class BonusProgramConverter {
  convertGift = t => ({
    id: t.id,
    name: t.name,
    type: t.type,
    level: t.level,
    points: parseInt(t.coin_cost, 10),
    imageUrl: `/${t.image_url.replace('static/', 'internal_s3_media')}`,
    description: t.description ?? '',
    active: t.status,
    promocode: t.promo_code,
    moneyToBalance: t.money_to_balance,
    createdAt: t.created_at,
  });

  convertCurrentGifts = d => {
    const items = d?.gifts?.map(t => this.convertGift(t)) || [];

    return {
      items: items,
      count: d.count,
    };
  };
}
